module.exports = __webpack_public_path__ + "img/12.16e4b33f.png";